module.exports = __webpack_public_path__ + "img/horizontal_3_6_7042.940334b9.png";